import { render, staticRenderFns } from "./merchants-dialog.vue?vue&type=template&id=40cdb081&scoped=true"
import script from "./merchants-dialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./merchants-dialog.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./merchants-dialog.vue?vue&type=style&index=0&id=40cdb081&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40cdb081",
  null
  
)

export default component.exports